/* eslint no-param-reassign: 0 */
/* eslint no-underscore-dangle: 0 */
import { SERIAL_SETUP } from './helpers';

// Base de comunicación de IACO: Bluetooth de la app (BT1) + I2C con la ESP32-CAM.
// La comparten los bloques de IACO (botones, ángulo) y los de Cámara. Cada pieza
// va bajo una clave fija de definitions_/setups_/loop_ para que se emita una sola
// vez sin importar cuántos bloques la pidan ni en qué orden se generen.
// No se exporta desde index.js porque no es un generador.

export const IACO_BASE_DEFS_KEY = 'IACO_buttons_defs';
export const IACO_BASE_DEFS = `
#include <Wire.h>
#include <string.h>
#include <SoftwareSerial.h>

SoftwareSerial BT1(9, 8);
#define SLAVE_ADDR 0x08  // Dirección I²C del esclavo (ESP32-CAM)
int IACOangulo;
`;

export const CAMERA_BASE_KEY = 'CAMERA_base';
const CAMERA_BASE = `
#include <Camara_Edu.h>

Camara_Edu cam(BT1);  // escribe en el mismo BT1
`;

const COMM_KEY = 'IACO_comm';
const ANALIZAR_KEY = 'IACO_analizarMensaje';
const LEER_BT_KEY = 'CAMERA_leerBT';
const CAMERA_SETUP_KEY = 'CAMERA_setup';
const CAMERA_LOOP_KEY = 'CAMERA_loop';

// Versión del joystick de IACO (la de prod). Se usa solo si no hay cámara.
const IACO_COMM_DEFS = `
String pedidoWifi = "WREQ";
char command;
String bufferBT = "";

bool pedirPayload(char cmd, char* buffer, size_t maxLen) {
  memset(buffer, 0, maxLen);
  Wire.beginTransmission(SLAVE_ADDR);
  Wire.write((uint8_t)cmd);
  uint8_t err = Wire.endTransmission();
  if (err != 0) {
    Serial.print("[I2C] endTransmission err=");
    Serial.println(err);
    return false;
  }

  (void)Wire.requestFrom((int)SLAVE_ADDR, (int)maxLen, (int)true);
  while (Wire.available()) (void)Wire.read();
  delay(2);
  int n = Wire.requestFrom((int)SLAVE_ADDR, (int)maxLen, (int)true);
  if (n <= 0) return false;
  size_t i = 0;
  while (Wire.available() && i < maxLen - 1) {
    char c = Wire.read();
    if (c == '\\0') break;
    buffer[i++] = c;
  }
  buffer[i] = '\\0';
  return i > 0;
}

void solicitarWifi() {
  char msgW[64];        // "WS<ssid>WSWP<pass>WP"
  char msgI[24];        // "WI<ip>WI"
  char combinado[160];  // "WS<ssid>WSWP<pass>WPWI<ip>WI"

  bool okW = pedirPayload('W', msgW, sizeof(msgW));
  bool okI = pedirPayload('I', msgI, sizeof(msgI));

  if (okW && okI) {
    // Formato final requerido: WS<ssid>WSWP<password>WPWI<ip>WI
    // Como msgW ya contiene la primera parte y msgI la segunda, concateno.
    combinado[0] = '\\0';
    strcpy(combinado, msgW);
    strcat(combinado, msgI);
    BT1.print(combinado);
    Serial.println(combinado);
    Serial.println("----");
  } else {
    if (!okW) Serial.println("[WARN] Error leyendo 'W'");
    if (!okI) Serial.println("[WARN] Error leyendo 'I'");
    Serial.println("----");
  }
}
`;

// Versión de la cámara: descarta basura, reintenta y termina la línea en BT1
// porque la librería también escribe ahí. Con cámara reemplaza a la de IACO.
const CAMERA_COMM_DEFS = `
String pedidoWifi = "WREQ";
char command;
String bufferBT = "";

// Le pide un dato a la camara por I2C: 'W' (nombre y clave de la red) o
// 'I' (IP). Escribe la letra, hace una lectura de descarte, espera 2 ms y
// lee la respuesta buena (la camara la prepara al recibir la letra).
bool pedirPayload(char cmd, char* buffer, size_t maxLen) {
  memset(buffer, 0, maxLen);
  Wire.beginTransmission(SLAVE_ADDR);
  Wire.write((uint8_t)cmd);
  uint8_t err = Wire.endTransmission();
  if (err != 0) {
    Serial.print("[I2C] endTransmission err=");
    Serial.println(err);
    return false;
  }

  (void)Wire.requestFrom((int)SLAVE_ADDR, (int)maxLen, (int)true);
  while (Wire.available()) (void)Wire.read();
  delay(2);
  int n = Wire.requestFrom((int)SLAVE_ADDR, (int)maxLen, (int)true);
  if (n <= 0) return false;
  size_t i = 0;
  while (Wire.available() && i < maxLen - 1) {
    char c = Wire.read();
    if (c == '\\0') break;
    if (c < 32 || c > 126) return false;  // basura (ej. 0xFF): la camara corto la respuesta
    buffer[i++] = c;
  }
  buffer[i] = '\\0';
  return i > 0;
}

// WREQ: le pasa a la App los datos de la red de la camara, para que se
// conecte sola y muestre el video. Formato: WS<red>WSWP<clave>WPWI<ip>WI
void solicitarWifi() {
  char msgW[64];        // "WS<red>WSWP<clave>WP"
  char msgI[24];        // "WI<ip>WI"
  char combinado[160];

  bool okW = false, okI = false;
  for (int intento = 0; intento < 3 && !(okW && okI); intento++) {  // si falla, se reintenta
    if (!okW) okW = pedirPayload('W', msgW, sizeof(msgW));
    if (!okI) okI = pedirPayload('I', msgI, sizeof(msgI));
  }

  if (okW && okI) {
    strcpy(combinado, msgW);
    strcat(combinado, msgI);
    BT1.print(combinado);
    BT1.print('\\n');  // fin de linea: otros tambien escriben en BT1
    Serial.println(combinado);
  } else {
    Serial.println(F("[WiFi] la camara no contesto"));
  }
}
`;

const IACO_COMM_SETUP = `
  BT1.begin(9600);
  Wire.begin();           // UNO: SDA=A4, SCL=A5
  Wire.setClock(100000);  // 100 kHz
  delay(1200);
`;

const CAMERA_SETUP = `
  Wire.setWireTimeout(25000, true);  // si se traba el I2C, el Arduino no se cuelga
  cam.reportarBloques(true);
  cam.empezar();                     // espera a que la camara conteste
  cam.alActualizar(leerBT);          // la App sigue atendida en los "esperar hasta"
`;

const CAMERA_LOOP = `cam.actualizar();  // siempre la primera linea del loop
leerBT();`;

const LEER_BT = `
// Lee el Bluetooth y arma las lineas que manda la App (terminan en '\\n').
void leerBT() {
  while (BT1.available()) {
    command = BT1.read();
    bufferBT += command;
    if (command == '\\n') {
      analizarMensaje(bufferBT);
      bufferBT = "";
    }
  }
}
`;

// Las ramas del joystick se guardan por generación (definitions_ es un objeto
// nuevo en cada init) para poder rearmar analizarMensaje si la cámara llega después.
const joystickBranches = new WeakMap();

const hasCamera = (generator) => Boolean(generator.definitions_[CAMERA_BASE_KEY]);

// Una sola analizarMensaje para joystick y cámara. Sin cámara queda igual que en prod.
const writeAnalizarMensaje = (generator) => {
  const branches = joystickBranches.get(generator.definitions_) || '';
  const camera = hasCamera(generator);
  const header = camera ? '\n// Reparte cada linea que llega de la App.' : '';
  const cameraBranch = camera
    ? ` else {
    cam.atenderMensaje(mensaje);  // VREQ, QREQ, MODEn, LOADCOLOR, CLEARCOLOR
  }`
    : '';
  generator.definitions_[ANALIZAR_KEY] = `${header}
void analizarMensaje(String mensaje) {
  String inicioMensaje = mensaje.substring(0, 4);
  mensaje.trim();
  if (mensaje.equals(pedidoWifi)) {
    solicitarWifi();
  }${branches}${cameraBranch}
}

`;
};

// Pone `key` justo después de `afterKey`, sin reemplazar el objeto (el WeakMap lo
// usa de clave). Hace falta porque `cam` tiene que declararse después de BT1 y
// antes de analizarMensaje, aunque el joystick se haya generado primero.
const insertAfter = (obj, afterKey, key, value) => {
  if (obj[key] !== undefined) return;
  const keys = Object.keys(obj);
  const tail = keys.slice(keys.indexOf(afterKey) + 1).map((k) => [k, obj[k]]);
  tail.forEach(([k]) => { delete obj[k]; });
  obj[key] = value;
  tail.forEach(([k, v]) => { obj[k] = v; });
};

export const installIacoBase = (generator) => {
  generator.definitions_[IACO_BASE_DEFS_KEY] = IACO_BASE_DEFS;
};

const installComm = (generator) => {
  installIacoBase(generator);
  if (!hasCamera(generator)) generator.definitions_[COMM_KEY] = IACO_COMM_DEFS;
  generator.setups_[COMM_KEY] = IACO_COMM_SETUP;
};

// Joystick de IACO: `branches` son las ramas `else if` de analizarMensaje.
export const installIacoJoystick = (generator, branches) => {
  installComm(generator);
  joystickBranches.set(generator.definitions_, branches);
  writeAnalizarMensaje(generator);
};

export const installCamera = (generator) => {
  // Serial.begin antes que el resto del setup, como en el código base.
  generator.setups_.setup_serial = SERIAL_SETUP;
  installComm(generator);
  insertAfter(generator.definitions_, IACO_BASE_DEFS_KEY, CAMERA_BASE_KEY, CAMERA_BASE);
  generator.definitions_[COMM_KEY] = CAMERA_COMM_DEFS;
  writeAnalizarMensaje(generator);
  generator.definitions_[LEER_BT_KEY] = LEER_BT;
  generator.setups_[CAMERA_SETUP_KEY] = CAMERA_SETUP;
  // cam.actualizar() tiene que ir primero en el loop.
  if (!generator.loop_[CAMERA_LOOP_KEY]) {
    generator.loop_ = Object.assign(Object.create(null), { [CAMERA_LOOP_KEY]: CAMERA_LOOP }, generator.loop_);
  }
};
